import React from 'react';
import { get, isEmpty } from 'lodash';

import { useFormatMessage } from 'app/common/hooks';

import messages from './DealerHours.messages';

const DealerHours = ({ businessHours }) => {
  const hasPartsHours = !isEmpty(get(businessHours, 'PARTS'));
  const serviceHours = hasPartsHours
    ? get(businessHours, 'PARTS', {})
    : get(businessHours, 'SERVICE', {});
  const formatMessage = useFormatMessage();

  return (
    <div className="flex mb-5 mr-2 w-full flex-col">
      <h4 className="mt-3 mb-3 underline text-gray-700 font-semibold text-center text-lg">
        {formatMessage(
          hasPartsHours ? messages.partsTitle : messages.serviceTitle
        )}
      </h4>
      <Day day={'monday'} serviceHours={serviceHours} />
      <Day day={'tuesday'} serviceHours={serviceHours} />
      <Day day={'wednesday'} serviceHours={serviceHours} />
      <Day day={'thursday'} serviceHours={serviceHours} />
      <Day day={'friday'} serviceHours={serviceHours} />
      <Day day={'saturday'} serviceHours={serviceHours} />
      <Day day={'sunday'} serviceHours={serviceHours} />
    </div>
  );
};

/**
 * Format time from 24 hour to 12 hour. Example: 13:00 -> 1:00 PM. Aurora uses 12:00 as a closing time to mean midnight.
 * Ensure that "00:00" and "12:00" are treated as either noon or midnight, depending on if it's an opening or closing time.
 * @param timeString - 24 hour time string. May be null or undefined.
 * @param isClosing - Boolean indicating if the time is a closing time.
 * @return {string} - 12 hour time string. Example: 13:00 -> 1:00 PM
 */
function formatTime(timeString, isClosing = false) {
  if (isEmpty(timeString) || !timeString.includes(':')) {
    return undefined;
  }
  const [hourStr, minute] = timeString.split(':');
  let hour = parseInt(hourStr, 10);

  let displayHour = hour % 12;
  if (displayHour === 0) {
    displayHour = 12;
  }
  let leadingZero = displayHour < 10 ? '0' : '';

  let isAM;
  if (hour === 12) {
    isAM = isClosing;
  } else {
    isAM = hour < 12;
  }

  return `${leadingZero}${displayHour}:${minute} ${isAM ? 'AM' : 'PM'}`;
}

const Day = ({ day, serviceHours }) => {
  const formatMessage = useFormatMessage();
  const hours = get(serviceHours, day, {});
  const open = formatTime(get(hours, 'open'), false);
  const close = formatTime(get(hours, 'close'), true);
  const isEmptyHours = isEmpty(open) && isEmpty(close);
  const displayedTime = !isEmptyHours ? open + ' - ' + close : 'Closed';
  return (
    <div className="flex flex-row ml-5">
      <div className="mb-1 w-2/5">{formatMessage(messages.day, { day })}</div>
      <div className={'mb-1 w-1/12 xs:flex lg:hidden xl:flex'}></div>
      <div className="mb-1 w-3/5">{displayedTime}</div>
    </div>
  );
};

export default DealerHours;
export { DealerHours };
